(() => {
  const sections = document.querySelectorAll('[data-finished-components]');
  if (!sections.length) return;

  for (const section of sections) {
    const lines = [...section.querySelectorAll('[data-finished-line]')];
    const rootPath = `${(section.dataset.rootUrl || '/').replace(/\/?$/, '/')}`;
    const currency = section.dataset.currency || 'USD';
    const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style:'currency', currency
    }).format(Number(cents) / 100);
    const handles = [...new Set(lines.map(line => line.dataset.productHandle).filter(Boolean))];
    const products = new Map();
    let cursor = 0;

    const fetchWorker = async () => {
      while (cursor < handles.length) {
        const handle = handles[cursor++];
        try {
          const url = new URL(`${rootPath}products/${encodeURIComponent(handle)}.js`, location.origin);
          const response = await fetch(url, {credentials:'same-origin', signal:AbortSignal.timeout(15000)});
          if (response.ok) products.set(handle, await response.json());
        } catch (_) { /* A missing product stays unavailable. */ }
      }
    };

    void Promise.all(Array.from({length:Math.min(4, handles.length)}, fetchWorker)).then(() => {
      for (const line of lines) {
        const product = products.get(line.dataset.productHandle);
        const variant = product?.variants?.find(item => String(item.id) === line.dataset.variantId);
        const quantity = Number(line.dataset.quantity);
        const title = line.querySelector('[data-finished-title]');
        const description = line.querySelector('[data-finished-description]');
        const stock = line.querySelector('[data-finished-stock]');
        const price = line.querySelector('[data-finished-price]');
        const add = line.querySelector('[data-finished-component-add]');
        const image = line.querySelector('[data-finished-image]');
        const linkPlaceholder = line.querySelector('[data-finished-product-link]');
        if (!product || !variant || !Number.isSafeInteger(quantity) || quantity < 1) {
          stock.textContent = product ? 'Option unavailable' : 'Product unavailable';
          description.textContent = `${line.dataset.quantity || '—'} per set · Exact option unavailable`;
          continue;
        }
        const productUrl = new URL(`${rootPath}products/${encodeURIComponent(line.dataset.productHandle)}`, location.origin);
        productUrl.searchParams.set('variant', String(variant.id));
        title.textContent = product.title || line.dataset.productHandle;
        description.textContent = `${quantity} per set · ${variant.title || 'Default Title'}`;
        price.textContent = `${formatMoney(variant.price)} each`;
        stock.textContent = variant.available ? 'In stock' : 'Sold out';
        stock.classList.toggle('is-soldout', !variant.available);
        const link = document.createElement('a');
        link.className = 'text-link';
        link.href = productUrl.href;
        link.textContent = 'View product →';
        linkPlaceholder.replaceWith(link);
        const imageUrl = variant.featured_image?.src || product.featured_image || product.images?.[0];
        if (imageUrl) {
          const img = document.createElement('img');
          img.src = imageUrl;
          img.alt = product.title || '';
          img.loading = 'lazy';
          image.replaceChildren(img);
        }
        if (variant.available) {
          add.dataset.finishedComponentAdd = String(variant.id);
          add.disabled = false;
          add.hidden = false;
        }
      }
    });
  }
})();
